import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";

interface ConfirmDeleteDialogProps {
  title: string;
  /**
  Disables the Delete button and swaps its label - used when deletion is blocked (e.g. by dependents) rather than merely pending.
  */
  isBlocked?: boolean;
  confirmLabel?: string;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
}

/**
Shared chrome for every "delete this X?" confirmation (team/project/member) - callers supply the
context-specific body (impact details, blocked-reason explanations, etc.) as `children`.
*/
export const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({ title, isBlocked, confirmLabel = "Delete", isDeleting, onCancel, onConfirm, children }) => (
  <Dialog title={title} onClose={onCancel} width={420}>
    <div style={{ display: "grid", gap: 16 }}>{children}</div>
    <DialogActionsBar>
      <Button onClick={onCancel} disabled={isDeleting}>
        Cancel
      </Button>
      <Button themeColor="error" disabled={isDeleting || isBlocked} onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </DialogActionsBar>
  </Dialog>
);
